import codes from '@/codes';
import reg from '@/reg';
import vSelect from 'vue-select';
import _ from 'lodash';
import moment from 'moment-timezone';
import { Switch as cSwitch } from '@coreui/vue';
import * as htmlToImage from 'html-to-image';
import { saveAs } from 'file-saver';
import { VclFacebook } from 'vue-content-loading';

//restful api
import { partner as billing } from '@/service/api/billing';
import { billing_admin as billingService } from '@/service/api/billing';

export default {
  components: {
    cSwitch,
    vSelect,
    VclFacebook
  },
  data : () => {
    return {
      is_pay : false,
      loading : false,
      exporting : false,
      is_show : true,
      so : {
        perPage: 15,
        currentPage: 1, totalRows: 0,
        sk: 'service.name', sv: '', skt: 'Service', opt : {}
      },
      add : false,
      reg,
      confirm : false,
      model : { group : {}, partner : {}, hide_cancel : true, bill_custom : {}, group_list : [], group_list_cache : [] },
      lock : true,
      codes,
      // group with partner
      chainPartner : false,
      syncPartner : false,
      passPartner : false,
      // 일부 거래 기록
      payment_history : []
    }
  },
  computed: {
    // uuid() {
    //   return this.model && this.model.partner && this.model.partner.id ? `${location.hostname.replace('manager.', '')}-${this.model.partner.id}-${moment(this.model.partner).format('YYYY')}` : '-'
    // },
    pay_clear_css() {
      return `z-index:2; position:absolute; top: ${this.model.group_list_cache.length > 10 ? 500 : 440 - (this.exporting ? 60 : 0)}px; left: 40%; transform:rotate(-45deg);`
    }
  },
  methods: {
    async pay() {
      // console.log('is_partner_credit?', this.model.pay_price)
      // 파트너 크레딧을 사용하여 빌링 결제
      let rs = await billingService.payPAdmin(Object.assign({}, { id : this.model.id, amount : this.model.pay_price,  }));
      if(rs.error) {
        return this.$toastr.e('pay failed', rs.reason)
      } else {
        this.$toastr.s('Payment completed')
        this.model = Object.assign({}, this.model, rs.body)

        if(this.model.history) {
            this.payment_history = []
            this.model.history.forEach(r => {
              this.payment_history.push(typeof r == typeof 'string' ? JSON.parse(r) : r)
            });
          }
        this.$emit('refresh')
      }
    },
    async share() {
      try {
        if(this.exporting) { return; }
        this.exporting = true
        this.is_show = false

        console.log("Generating shared image")
        this.$toastr.i("Generating shared image")

        let blob = await htmlToImage.toBlob(document.getElementById('_share'))
        saveAs(blob, `${this.model.partner.username}_invoice_${this.model.apply_date}.png`);
        this.is_show = true
        this.exporting = false

        this.$toastr.s("Shared Image Creation Complete")
      } catch (e) { console.log(e); return this.$toastr.e("export image failed");  }
    },
    reload: function(val) {
      // console.log(val)
      this.model.group_list_cache = _.compact(_.map(this.model.group_list, r => {
        if(r.description == 'canceled') {
          return  !val ? r : ''
        }
        return r

      }))
    },
    list: function() { this.$router.push({ name: 'InvoicePartner' }); this.$emit('refresh'); },
    getRowCount () { return this.so.totalRows || 0; },
    async partnerSave() {
      try {
        this.model.partner_id = this.model.partner.id;

        // let rs = await Api.Manager_Call('invoice.partner', 'update', Object.assign({}, this.model, { partner : {} }, this.region));
        let rs = await billing.updatePartner(Object.assign({}, this.model, { partner : {} }, this.region));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.refresh(rs.body.id);
        } else {
          this.$toastr.e('Save', "failed"); this.refresh();
        }
        this.syncPartner = false;
      } catch (e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); }
    },
    get: async function({ id, tag, invoice_id } = this.$route.params) {
      this.loading = true
      console.log('invoice.partner.detail.vue', 'load item', id, invoice_id);
      if(id === 'add' || tag === 'invoice') { this.model.is_verified = true; this.add = (tag != 'invoice'); this.lock = false; return; }
      else {
        billing.detailPartner({ id : id, invoice_id : invoice_id })
          .then(rs => {
            if(rs.error) { return this.$toastr.e("load faild", this.$route.name); }
            this.model = Object.assign({}, this.model, rs.body)
            if(this.model.history) {
              this.payment_history = []
              this.model.history.forEach(r => {
                this.payment_history.push(typeof r == typeof 'string' ? JSON.parse(r) : r)
              });
            }

            // set days
            this.model.start = moment(this.model.apply_date, 'YYYYMM').format('YYYY-MM-01')
            this.model.end = moment(this.model.apply_date, 'YYYYMM').format('YYYY-MM-'+moment(this.model.apply_date, 'YYYYMM').daysInMonth())

            this.model.group_list_cache = this.model.group_list
            this.reload(this.model.hide_cancel)

            // if(this.model.group_list_cache) {
            //   this.model.total_usage = _.sumBy(this.model.group_list_cache, x => x.total_usage)
            //   this.model.wc_usage = _.sumBy(this.model.group_list_cache, x => x.wc_usage)
            //   this.model.wsf_usage = _.sumBy(this.model.group_list_cache, x => x.wsf_usage)
            //   this.model.wf_usage = _.sumBy(this.model.group_list_cache, x => x.wf_usage)
            //   this.model.wmds_usage = _.sumBy(this.model.group_list_cache, x => x.wsf_usage)
            // }
            this.loading = false
          })
          .catch(e => {
            console.log(e);
            (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list())
          });
      }
    },
    refresh(id) {
      this.$router.push({ name: 'invoice', params : { id : id ? id : this.$route.params.id } }); this.$emit('refresh');
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('invoice.partner.detail.vue', 'created'); },
  destroyed: function() { console.log('invoice.partner.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('invoice.partner.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}